import React from "react";
import { Admin, Resource, Delete } from "admin-on-rest";
import { RestClient } from "./restClient";
import authClient from "./authClient";
import translations from "./i18n";
import Menu from "./menu";
import LoginPage from "./auth/LoginPage";

import { CategoriesList, CategoryCreate, CategoryEdit } from "./categories";
import {
  CollectionsList,
  CollectionCreate,
  CollectionEdit
} from "./collections";
import { PagesList, PageCreate, PageEdit } from "./pages";
import { StaticList, StaticCreate, StaticEdit } from "./static";
import { ProductsList, ProductCreate, ProductEdit } from "./products";
import { OrdersList, OrderEdit } from "./orders";
import {
  MarketersList,
  MarketerCreate,
  MarketerEdit,
  MarketerShow
} from "./marketers";
import {
  TransfersList,
  TransferCreate,
  TransferEdit
} from "./marketers/transfers";
import { InventoryList } from "./reports/Inventory";
import { SalesReportList } from "./reports/Sales";
import {
  TemplateList,
  TemplateCreate,
  TemplateEdit,
  TemplateShow
} from "./contents";
import { muiTheme } from "./theme";
import { AccountsList, AccountCreate, AccountEdit } from "./accounts";
import { UsersList, UserCreate, UserEdit } from "./users";
import { CampaignsList, CampaignCreate, CampaignEdit } from "./campaigns";
import { CustomersList, CustomerEdit } from "./customers";
import { TicketList } from "./tickets";
/* import {
  ReloadsList,
  ReloadsCreate,
  ReloadsEdit,
  ReloadsShow
} from "./reloads";*/

import { PaymentList, PaymentCreate, PaymentEdit } from "./payment";
import {
  PaymentModeList,
  PaymentModeCreate,
  PaymentModeEdit
} from "./paymentmode";
import { SimList } from "./sim";
import { ActivationList, ActivationShow } from "./activations";
import { AgencyList, AgencyCreate, AgencyEdit } from "./agency";

import { agencymarketer } from "./agency/redux";

// import jsonRestClient from "aor-json-rest-client";
// import { data } from "./DummyData";
// import RootLayout from './RootLayout';
// restClient={jsonRestClient(data)}
// RestClient
//restClient={RestClient}

import customRoutes from "./customRoutes";
import Dashboard from "./Dashboard";
import {
  CorporateCampaignList,
  CorporateCampaignCreate,
  CorporateCampaignEdit
} from "./corporate_campaign";

export const ROLE_ADMIN = "Admin";
export const ROLE_PARTNER_ADMIN = "Partner Admin";
export const ROLE_PARTNER_USER = "Partner User";
export const ROLE_RECRUITER = "Recruiter"; //Recruiter
export const ROLE_CORPORATE = "Corporate Campaign";
const App = () => (
  <Admin
    title="Ola Admin"
    menu={Menu}
    dashboard={Dashboard}
    customReducers={{ agencymarketer }}
    customRoutes={customRoutes}
    authClient={authClient}
    loginPage={LoginPage}
    restClient={RestClient}
    messages={translations}
    theme={muiTheme}
  >
    {permissions => {
      return [
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Products" }}
            name="products"
            list={ProductsList}
            create={ProductCreate}
            edit={ProductEdit}
            remove={Delete}
          />
        ) : null,
        permissions === ROLE_PARTNER_ADMIN ? (
          <Resource
            options={{ label: "Products" }}
            name="products"
            list={ProductsList}
            create={ProductCreate}
            edit={ProductEdit}
            remove={Delete}
          />
        ) : null,
        permissions === ROLE_PARTNER_USER ? (
          <Resource
            options={{ label: "Products" }}
            name="products"
            list={ProductsList}
            create={ProductCreate}
            edit={ProductEdit}
            remove={Delete}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Orders" }}
            name="orders"
            list={OrdersList}
            edit={OrderEdit}
          />
        ) : null,
        permissions === ROLE_PARTNER_ADMIN ? (
          <Resource
            options={{ label: "Orders" }}
            name="orders"
            list={OrdersList}
            edit={OrderEdit}
          />
        ) : null,
        permissions === ROLE_PARTNER_USER ? (
          <Resource
            options={{ label: "Orders" }}
            name="orders"
            list={OrdersList}
            edit={OrderEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Sales Reports" }}
            name="reports/sales"
            list={SalesReportList}
          />
        ) : null,
        permissions === ROLE_PARTNER_ADMIN ? (
          <Resource
            options={{ label: "Sales Reports" }}
            name="reports/sales"
            list={SalesReportList}
          />
        ) : null,
        permissions === ROLE_PARTNER_USER ? (
          <Resource
            options={{ label: "Sales Reports" }}
            name="reports/sales"
            list={SalesReportList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Categories" }}
            name="categories"
            list={CategoriesList}
            create={CategoryCreate}
            edit={CategoryEdit}
          />
        ) : null,
        permissions === ROLE_PARTNER_ADMIN ? (
          <Resource
            options={{ label: "Categories" }}
            name="categories"
            list={CategoriesList}
          />
        ) : null,
        permissions === ROLE_PARTNER_USER ? (
          <Resource
            options={{ label: "Categories" }}
            name="categories"
            list={CategoriesList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Collections" }}
            name="collections"
            list={CollectionsList}
            create={CollectionCreate}
            edit={CollectionEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Pages" }}
            name="pages"
            list={PagesList}
            create={PageCreate}
            edit={PageEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "HTML" }}
            name="statics"
            list={StaticList}
            create={StaticCreate}
            edit={StaticEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Account" }}
            name="marketers"
            list={MarketersList}
            create={MarketerCreate}
            edit={MarketerEdit}
            show={MarketerShow}
          />
        ) : null,
        permissions === ROLE_RECRUITER ? (
          <Resource
            options={{ label: "Account" }}
            name="marketers"
            list={MarketersList}
            create={MarketerCreate}
            edit={MarketerEdit}
            show={MarketerShow}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Transfers" }}
            name="transfers"
            list={TransfersList}
            create={TransferCreate}
            edit={TransferEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Inventory Reports" }}
            name="reports/inventory"
            list={InventoryList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Template" }}
            name="contents"
            list={TemplateList}
            create={TemplateCreate}
            edit={TemplateEdit}
            show={TemplateShow}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Accounts" }}
            name="accounts"
            list={AccountsList}
            create={AccountCreate}
            edit={AccountEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Users" }}
            name="users"
            list={UsersList}
            create={UserCreate}
            edit={UserEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Campaigns" }}
            name="campaigns"
            list={CampaignsList}
            create={CampaignCreate}
            edit={CampaignEdit}
          />
        ) : null,
        permissions === ROLE_RECRUITER ? (
          <Resource
            options={{ label: "Campaigns" }}
            name="campaigns"
            list={CampaignsList}
            create={CampaignCreate}
            edit={CampaignEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Customers" }}
            name="customers"
            list={CustomersList}
            edit={CustomerEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? <Resource name="products/sku" /> : null,
        permissions === ROLE_ADMIN ? <Resource name="reports/orders" /> : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Tickets" }}
            name="ticket"
            list={TicketList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Payments" }}
            name="payment"
            list={PaymentList}
            create={PaymentCreate}
            edit={PaymentEdit}
          />
        ) : null,
        permissions === ROLE_PARTNER_ADMIN ? (
          <Resource
            options={{ label: "Payment Mode" }}
            name="paymentmode"
            list={PaymentModeList}
          />
        ) : null,
        permissions === ROLE_PARTNER_USER ? (
          <Resource
            options={{ label: "Payment Mode" }}
            name="paymentmode"
            list={PaymentModeList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Payment Mode" }}
            name="paymentmode"
            list={PaymentModeList}
            create={PaymentModeCreate}
            edit={PaymentModeEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Sim Cards" }}
            name="sim"
            list={SimList}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Activations" }}
            name="activations"
            list={ActivationList}
            show={ActivationShow}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Agency" }}
            name="agency"
            list={AgencyList}
            create={AgencyCreate}
            edit={AgencyEdit}
          />
        ) : null,
        permissions === ROLE_ADMIN ? (
          <Resource
            options={{ label: "Corporate Campaigns" }}
            name="corporate_campaign"
            list={CorporateCampaignList}
            create={CorporateCampaignCreate}
            edit={CorporateCampaignEdit}
          />
        ) : null
      ];
    }}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js